import React from "react";
import PropTypes from "prop-types";

function ResetCrmConnectionMessage({ crm }) {
  return (
    <div data-test="reset-crm-connection-msg">
      <p>
        To reset the credentials utilized by Hubly for connecting with your{" "}
        {crm} account, pleased provide the updated credentials below.
      </p>

      <p>
        Once you reset your credentials, a sync will start and you won&apos;t be
        able to see your clients until the sync is completed.
      </p>
    </div>
  );
}

ResetCrmConnectionMessage.propTypes = {
  crm: PropTypes.string.isRequired,
};

ResetCrmConnectionMessage.defaultProps = {};

export default ResetCrmConnectionMessage;
